import { render, staticRenderFns } from "./departmental.vue?vue&type=template&id=3ef85bfc&scoped=true&"
import script from "./departmental.vue?vue&type=script&lang=js&"
export * from "./departmental.vue?vue&type=script&lang=js&"
import style0 from "./departmental.vue?vue&type=style&index=0&id=3ef85bfc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef85bfc",
  null
  
)

export default component.exports